import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { useBillingData } from "./hooks/useBillingData";
import { useFinalBillPreview } from "./hooks/useFinalBillPreview";
import ProformaSection from "./components/ProformaSection";
import FinalBillSection from "./components/FinalBillSection";
import LinkedRestaurantBillsSection from "./components/LinkedRestaurantBillsSection";
import { useLinkedBills } from "./hooks/useLinkedBills";

const BillingTab = ({ bookingDetails, colors }) => {
  const { hotelProfile } = useSelector((state) => ({
    hotelProfile: state.registration.hotelProfile,
  }));
  const gstEnabled = hotelProfile?.gst_enabled;

  const {
    isEditing,
    invoiceData,
    lineItems,
    grandTotal,
    hasFinalBill,
    finalBillSummary,
    handleHeaderChange,
    handleLineItemChange,
    addLineItem,
    removeLineItem,
    toggleEditing,
  } = useBillingData(bookingDetails, gstEnabled);

  const {
    openPreview: openFinalBillPreview,
    loading: finalBillLoading,
    previewData: finalBillPreviewData, // <--- Destructure previewData
    error: finalBillError,
    handlePreview: handleFinalBillPreview,
    closePreview: closeFinalBillPreview,
    retryPreview: retryFinalBillPreview,
    navigateToFinalBill,
  } = useFinalBillPreview(bookingDetails, hasFinalBill);

  const { 
    linkedBills, 
    loading: linkedBillsLoading, 
    error: linkedBillsError 
  } = useLinkedBills(bookingDetails);

  return (
    <Box>
      {/* PROFORMA INVOICE SECTION */}
      <ProformaSection
        bookingDetails={bookingDetails}
        hotelProfile={hotelProfile}
        colors={colors}
        invoiceData={invoiceData}
        lineItems={lineItems}
        grandTotal={grandTotal}
        isEditing={isEditing}
        onHeaderChange={handleHeaderChange}
        onLineItemChange={handleLineItemChange}
        onAddItem={addLineItem}
        onRemoveItem={removeLineItem}
        onToggleEditing={toggleEditing}
        gstEnabled={gstEnabled}
      />

      {/* 2. LINKED RESTAURENT BILLS SECTION (NEW) */}
      <LinkedRestaurantBillsSection
        colors={colors}
        linkedBills={linkedBills}
        loading={linkedBillsLoading}
        error={linkedBillsError}
      />

    {/* FINAL BILL SECTION */}
      <FinalBillSection
        colors={colors}
        hasFinalBill={hasFinalBill}
        invoiceId={bookingDetails?.invoice_id}
        finalBillSummary={finalBillSummary}       
        hotelProfile={hotelProfile} // <--- Pass Profile prop
        openPreview={openFinalBillPreview}
        loading={finalBillLoading}
        previewData={finalBillPreviewData} // <--- Pass Data prop
        error={finalBillError}
        onPreview={handleFinalBillPreview}
        onClosePreview={closeFinalBillPreview}
        onRetryPreview={retryFinalBillPreview}
        onNavigateToFinalBill={navigateToFinalBill}
      />
    </Box>
  );
};

export default BillingTab;